import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Kentucky = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Kentucky Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Disclosure of material facts required; no specific form mandated.
        </Text>

        <Text style={styles.listItem}>
          2. Seller's Disclosure of Property Condition Form: Mandatory for most
          transactions.
        </Text>

        <Text style={styles.listItem}>
          3. Flood Plain Disclosure: Required if the property is in a flood
          plain.
        </Text>

        <Text style={styles.listItem}>
          4. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          5.{' '}
          <Text style={styles.underline}>
            Seller's Disclosure of Property Condition
          </Text>{' '}
          – As Kentucky is not a buyer-beware state, sellers must provide full
          disclosure of the property's condition prior to signing a purchase
          agreement.
        </Text>
      </View>
    </View>
  );
};

export default Kentucky;
